export default "__VITE_ASSET__1edf1299__"